import {styled} from "@mui/material/styles";
import {black500, blueColor} from "../../../assets/jss/main";

export const BpIcon = styled('span')(({theme}) => ({
    borderRadius: 4,
    width: 20,
    height: 20,
    backgroundColor: '#FFFFFF',
    border: `1px solid ${black500}`
}));

export const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: blueColor,
    border: `1px solid ${blueColor}`,
    '&:before': {
        display: 'block',
        width: 20,
        height: 20,
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18 '%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#106ba3',
    },
});